import { createRoot } from "react-dom/client";

import "./style.scss";
// import BPlayer from "./BPlayer";

import jsonParse from "./../../wp-utils/v1/jsonParse";
import dataParser from "../../wp-utils/v1/dataParser";
// import htmlToElement from "../../wp-utils/v1/htmlToElement";
import View from "./blocks/timeline/View";

document.addEventListener("DOMContentLoaded", function () {
  // video block;
  const players = document.querySelectorAll(".ytPlayer");
  players.forEach((wrapper) => {
    const element = wrapper.querySelector("#player");

    // detect dataset
    const { options } = dataParser(jsonParse(wrapper?.dataset?.preset) || {});
    const { preload } = dataParser(jsonParse(wrapper?.dataset?.attributes) || {});

    // remove dataset attributes
    wrapper.removeAttribute("data-preset");
    wrapper.removeAttribute("data-attributes");

    if (!options) {
      return false;
    }

    if (!options.controls) {
      options.controls = [];
      options.clickToPlay = true;
    }

    const playerInstance = new Plyr(element, { ...options, preload });

    // const player

    // hide large play button for 200 millisecond
    playerInstance.on("pause", function () {
      const largePlayBtn = this.querySelector(".plyr__control--overlaid");
      if (largePlayBtn) {
        largePlayBtn.style.display = "none";
        setTimeout(() => {
          largePlayBtn.style.display = "block";
        }, 200);
      }
    });
    // const containerElem = playerInstance?.elements.container;
    // if (containerElem && preset?.watermark?.enabled) {
    //   containerElem.appendChild(htmlToElement(`<div class="watermark"><span>${preset?.watermark?.text}</span></div>`));
    // }
    window.playerInstance = playerInstance;
  });

  // timeline block
  const timelineBlocks = document.querySelectorAll(".timelineBlock");
  // console.log(timelineBlocks);

  timelineBlocks.forEach((blockDom) => {
    const attributes = jsonParse(blockDom.dataset.attributes);

    // remove dataset attributes
    blockDom.removeAttribute("data-attributes");

    // console.log(blockDom, attributes);

    const VideoBox = ({ heading, content }) => {
      return (
        <div className="videoText">
          <div className="content">
            <h3 dangerouslySetInnerHTML={{ __html: heading }}></h3>
            <p dangerouslySetInnerHTML={{ __html: content }}></p>
          </div>
        </div>
      );
    };
    const root = createRoot(blockDom);
    root.render(<View attributes={attributes} VideoBox={VideoBox}></View>);
  });
});
